import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import Url from "../../../Common/Url";

const Edit = (props) => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const { id } = useParams();
  const [error, setError] = useState({});
  const [vendorCode, setVendorCode] = useState({});
  // if upload has any File
  const [selectedFile1, setSelectedFile1] = useState();
  const [selectedFile2, setSelectedFile2] = useState();
  const [selectedFile3, setSelectedFile3] = useState();
  const [selectedFile4, setSelectedFile4] = useState();
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true); // Start loading
    try {
      const res = await Http.get("/vendor/" + id + "/edit");
      setInputs({
        code: res.data.code,
        name: res.data.name,
        contact_person: res.data.contact_person,
        contact_phone: res.data.contact_phone,
        secondary_phone: res.data.secondary_phone,
        email: res.data.email,
        present_address: res.data.present_address,
        permanent_address: res.data.permanent_address,
        website: res.data.website,
        previous_due: res.data.previous_due,
        notes: res.data.notes,
        license_no: res.data.vendor_documents
          ? res.data.vendor_documents.license_no
          : "",
        license_img: res.data.vendor_documents
          ? res.data.vendor_documents.license_img
          : "",
        license_no_validaty_date: res.data.vendor_documents
          ? res.data.vendor_documents.license_no_validaty_date
          : "",
        vat_reg_no: res.data.vendor_documents
          ? res.data.vendor_documents.vat_reg_no
          : "",
        vat_reg_img: res.data.vendor_documents
          ? res.data.vendor_documents.vat_reg_img
          : "",
        vat_reg_no_validaty_date: res.data.vendor_documents
          ? res.data.vendor_documents.vat_reg_no_validaty_date
          : "",
        tin_no: res.data.vendor_documents
          ? res.data.vendor_documents.tin_no
          : "",
        tin_no_validaty_date: res.data.vendor_documents
          ? res.data.vendor_documents.tin_no_validaty_date
          : "",
        tin_img: res.data.vendor_documents
          ? res.data.vendor_documents.tin_img
          : "",
        nid: res.data.vendor_documents ? res.data.vendor_documents.nid : "",
        nid_img: res.data.vendor_documents
          ? res.data.vendor_documents.nid_img
          : "",
      });
      setVendorCode(res.data.code);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // const fetchData = () => {
  //   Http.get("/vendor/" + id + "/edit").then((res) => {
  //     setInputs({
  //       code: res.data.code,
  //       name: res.data.name,
  //       contact_person: res.data.contact_person,
  //       contact_phone: res.data.contact_phone,
  //       secondary_phone: res.data.secondary_phone,
  //       email: res.data.email,
  //       present_address: res.data.present_address,
  //       permanent_address: res.data.permanent_address,
  //       website: res.data.website,
  //       previous_due: res.data.previous_due,
  //       notes: res.data.notes,
  //       license_no: res.data.vendor_documents ? res.data.vendor_documents.license_no : "",
  //       license_img: res.data.vendor_documents ? res.data.vendor_documents.license_img : "",
  //       license_no_validaty_date: res.data.vendor_documents ? res.data.vendor_documents.license_no_validaty_date : "",
  //       vat_reg_no: res.data.vendor_documents ? res.data.vendor_documents.vat_reg_no : "",
  //       vat_reg_img: res.data.vendor_documents ? res.data.vendor_documents.vat_reg_img : "",
  //       vat_reg_no_validaty_date: res.data.vendor_documents ? res.data.vendor_documents.vat_reg_no_validaty_date : "",
  //       tin_no: res.data.vendor_documents ? res.data.vendor_documents.tin_no : "",
  //       tin_no_validaty_date: res.data.vendor_documents ? res.data.vendor_documents.tin_no_validaty_date : "",
  //       tin_img: res.data.vendor_documents ? res.data.vendor_documents.tin_img : "",
  //       nid: res.data.vendor_documents ? res.data.vendor_documents.nid : "",
  //       nid_img: res.data.vendor_documents ? res.data.vendor_documents.nid_img : "",
  //     });
  //     setVendorCode(res.data.code);
  //   });
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // if upload has any File
  const handleFileChange1 = (e) => {
    setSelectedFile1(e.target.files[0]);
  };
  const handleFileChange2 = (e) => {
    setSelectedFile2(e.target.files[0]);
  };
  const handleFileChange3 = (e) => {
    setSelectedFile3(e.target.files[0]);
  };
  const handleFileChange4 = (e) => {
    setSelectedFile4(e.target.files[0]);
  };

  const formSubmit = () => {
    inputs.license_img = selectedFile1;
    inputs.vat_reg_img = selectedFile2;
    inputs.tin_img = selectedFile3;
    inputs.nid_img = selectedFile4;
    inputs.code = vendorCode;
    Http.put("/vendor/" + id, inputs)
      .then((res) => {
        navigate("/vendors", {
          state: { message: res.data.message, type: res.data.type },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  return (
    <div>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Vendor</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            {/* <h6 className="card-body-title mg-sm-b-30">Edit Unit Form</h6> */}
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Code <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="code"
                      value={inputs.code || ""}
                      onChange={handleChange}
                      placeholder="Input Code"
                    />
                  </div>
                  {/* col */}
                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label>
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Input Name"
                      required
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg">
                    <label>
                      Contact Person <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="contact_person"
                      value={inputs.contact_person || ""}
                      onChange={handleChange}
                      placeholder="Input contact person"
                    />
                  </div>
                  {/* col */}
                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label>
                      Contact Phone <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="contact_phone"
                      value={inputs.contact_phone || ""}
                      onChange={handleChange}
                      placeholder="Input contact phone"
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Secondary Phone</label>
                    <input
                      type="text"
                      className="form-control"
                      name="secondary_phone"
                      value={inputs.secondary_phone || ""}
                      onChange={handleChange}
                      placeholder="Input secondary phone"
                    />
                  </div>
                  {/* col */}
                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={inputs.email || ""}
                      onChange={handleChange}
                      placeholder="Input email"
                      required
                    />
                  </div>
                </div>
                {/* 8 9 12  */}
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Website</label>
                    <input
                      type="text"
                      className="form-control"
                      name="website"
                      value={inputs.website || ""}
                      onChange={handleChange}
                      placeholder="Input website"
                    />
                  </div>
                  {/* col */}
                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label>Previous Due</label>
                    <input
                      type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                      className="form-control"
                      name="previous_due"
                      value={inputs.previous_due || ""}
                      onChange={handleChange}
                      placeholder="Input previous due"
                    />
                  </div>
                </div>

                {/* NID */}
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>
                      NID No <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="nid"
                      value={inputs.nid || ""}
                      onChange={handleChange}
                      placeholder="Input license no"
                    />
                  </div>
                  <div className="col-lg">
                    <label>NID Img</label>
                    <input
                      type="file"
                      className="form-control"
                      name="nid_img"
                      onChange={handleFileChange4}
                      placeholder="Input license no"
                    />
                    {inputs.nid_img != "" ? (
                      <a
                        href={Url + "vendor_documents/" + inputs.nid_img}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Download
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {/* license */}
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>
                      License No <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="license_no"
                      value={inputs.license_no || ""}
                      onChange={handleChange}
                      placeholder="Input license no"
                    />
                  </div>
                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label>Validity Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="license_no_validaty_date"
                      value={inputs.license_no_validaty_date || ""}
                      onChange={handleChange}
                      placeholder="Input contact phone"
                    />
                  </div>
                  <div className="col-lg">
                    <label>License Img</label>
                    <input
                      type="file"
                      className="form-control"
                      name="license_img"
                      onChange={handleFileChange1}
                      placeholder="Input license no"
                    />
                    {inputs.license_img != "" ? (
                      <a
                        href={Url + "vendor_documents/" + inputs.license_img}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Download
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {/* Vat */}
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Vat Reg. No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="vat_reg_no"
                      value={inputs.vat_reg_no || ""}
                      onChange={handleChange}
                      placeholder="Input license no"
                    />
                  </div>
                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label>Validity Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="vat_reg_no_validaty_date"
                      value={inputs.vat_reg_no_validaty_date || ""}
                      onChange={handleChange}
                      placeholder="Input contact phone"
                    />
                  </div>
                  <div className="col-lg">
                    <label>Vat Img</label>
                    <input
                      type="file"
                      className="form-control"
                      name="vat_reg_img"
                      onChange={handleFileChange2}
                      placeholder="Input license no"
                    />
                    {inputs.vat_reg_img != "" ? (
                      <a
                        href={Url + "vendor_documents/" + inputs.vat_reg_img}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Download
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                {/* TIN */}
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>TIN No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="tin_no"
                      value={inputs.tin_no || ""}
                      onChange={handleChange}
                      placeholder="Input license no"
                    />
                  </div>
                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label>Validity Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="tin_no_validaty_date"
                      value={inputs.tin_no_validaty_date || ""}
                      onChange={handleChange}
                      placeholder="Input contact phone"
                    />
                  </div>
                  <div className="col-lg">
                    <label>TIN Img</label>
                    <input
                      type="file"
                      className="form-control"
                      name="tin_img"
                      onChange={handleFileChange3}
                      placeholder="Input license no"
                    />
                    {inputs.tin_img != "" ? (
                      <a
                        href={Url + "vendor_documents/" + inputs.tin_img}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Download
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Present Address</label>
                    <textarea
                      name="present_address"
                      className="form-control"
                      cols="30"
                      rows="5"
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <div className="col-lg">
                    <label>Permanent Address</label>
                    <textarea
                      name="permanent_address"
                      className="form-control"
                      cols="30"
                      rows="5"
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <div className="col-lg">
                    <label>Remarks</label>
                    <textarea
                      name="notes"
                      className="form-control"
                      cols="30"
                      rows="5"
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  {/* col */}
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Edit;
